import React from 'react';
import { Table } from 'templates/mdp/components/react-table';
import { Skeleton } from 'core/cells/skeleton';
import { Card, CardBody } from 'templates/mdp/components/card';
import { createReactTableStore } from 'core/memory/pure/react-table-store';
import { useGetTermsState } from 'core/memory/apollo/terms/local/get-terms-state';
import { useReactTableState } from 'core/metabolism/table-state';
import { Carer } from 'modules/student/dna/types/carer';
import { useCarerTableRead } from './use-carer-table-read';

interface UseCarerTableProps {
  data: Carer[] | undefined;
  loading: boolean;
}

export const carerTableStore = createReactTableStore({}, {});

export const CarerTable = (props: UseCarerTableProps) => {
  const { data, loading } = props;

  const { columns, tableData } = useCarerTableRead(data);
  const { data: termsState } = useGetTermsState();

  const {
    initialPage,
    pageSize,
    sort,
    filters,
    setSort,
    setFilters,
    setPage,
    setPageSize,
  } = useReactTableState(carerTableStore, termsState?.selected ?? undefined);

  return loading || !termsState?.selected ? (
    <Skeleton variant="rect" width="100%" height="300px" />
  ) : (
    <Card>
      <CardBody>
        <Table
          noActions
          noPagination
          columns={columns}
          data={tableData}
          key={termsState?.selected ?? 'unknown_term'}
          onChangeRowsPerPage={setPageSize}
          onChangePage={setPage}
          onFilterChange={setFilters}
          onOrderChange={setSort}
          options={{
            initialPage,
            pageSize,
            sort,
            filters,
          }}
        />
      </CardBody>
    </Card>
  );
};
